import $ from 'jquery';

const REGEXPS = {
  HOTKEYS: {
    AMPERSAND_CHAR: /(^|\b|[^&])&([A-Za-z])/,
    DOUBLE_AMPERSAND: /&&/g
  }
}


function hotkeys() {
  this.map = {};
}

hotkeys.prototype.add = function (key, obj) {
  var found = false;
  var list = this.map[key] = (this.map[key] || []);
  for (var i = list.length - 1; i >= 0 && !found; --i) {
    var entry = list[i];
    if (entry.id === obj.id && entry.index === obj.index)
      found = true;
  }
  if (!found)
    list.push(obj);
};

hotkeys.prototype.apply = function (value, obj) {
  var self = this;
  var key;
  value = value.replace(
    REGEXPS.HOTKEYS.AMPERSAND_CHAR,
    function (_, prev, hotkey) {
      self.replace(key = hotkey.toLowerCase(), obj);
      return prev + hotkey + '\u0332';
    }
  ).replace(REGEXPS.HOTKEYS.DOUBLE_AMPERSAND, '&');
  return [value, key];
};

hotkeys.prototype.find = function (current, key) {
  const CONTAINER_SELECTOR = '.k-content[role="tabpanel"], .k-window-content';
  var target;
  var list = this.map[key];
  if (list)
    for (var i = list.length - 1, last, found = []; i >= 0; --i) {
      var hotkey = list[i];
      target = $('#' + hotkey.id).first();
      if (target.length) {
        last = target;
        if (!target.closest('.k-content[aria-hidden]').length)
          found.push(target);
      }
    }
  console.debug('find hotkey:', found);
  switch (found.length) {
  case 0:
    target = last;
    break;
  case 1:
    target = found[0];
    break;
  default:
    // if there's more than one valid target, use the first one that's in the
    // same container as the currently-focused field
    console.debug('find hotkey:', $(current).closest(CONTAINER_SELECTOR));
    if (current = $(current).closest(CONTAINER_SELECTOR))
      for (var j = found.length - 1; j >= 0; --j) {
        target = found[j];
        console.debug('find hotkey:', target, target.closest(CONTAINER_SELECTOR));
        if (current.length && current.is(target.closest(CONTAINER_SELECTOR)))
          break;
      }
  }
  console.debug('find hotkey:', target, target.data('role'));
  if (target && target.data('role') === 'tabstrip')
    target = target.children('ul').children('li').eq(hotkey.index);
  console.debug('find hotkey:', target);
  return target;
};

hotkeys.prototype.remove = function (key, obj) {
  if (!obj) {
    obj = key;
    key = undefined;
  }
  var keys = key ? [key] : Object.keys(this.map);
  for (var list, i = keys.length - 1; i >= 0; --i)
    if (list = this.map[keys[i]])
      for (var j = list.length - 1; j >= 0; --j) {
        var entry = list[j];
        if (entry.id === obj.id && entry.index === obj.index)
          return list.splice(j, 1);
      }
};

hotkeys.prototype.replace = function (key, obj) {
  this.remove(key, obj);
  this.add(key, obj);
};


export default hotkeys;
